<script>
/**
 * Component: Packages: Tiers
 *
 * @author PH
 */
export default {
  props: ["current", "tiers"],

  data: function() {
    return {};
  },

  computed: {
    value: {
      get() {
        return this.$store.getters.getSectionSettings("packages", "tiers")
          .current;
      },
      set(value) {
        const settings = this.$store.getters.getSectionSettings(
          "packages",
          "tiers"
        );
        if (settings) {
          settings.current = value;

          this.$store.commit("updateSectionSettings", {
            section: "packages",
            values: {
              tiers: settings
            }
          });
        }
      }
    }
  }
};
</script>

<template>
  <div class="signup-packages-tiers">
    <div class="signup-packages-tiers__title">
      <p>Please select your Tier:</p>
    </div>
    <div class="signup-packages-tiers__select">
      <select name="test" id="test" v-model.lazy="value">
        <option
          v-for="tier in tiers"
          v-bind:key="tier.id"
          :value="tier.id"
        >{{tier.title}}: {{tier.description}}</option>
      </select>
    </div>
  </div>
</template>

